
export namespace ACApprovalWorkflowForm {
  export interface ACApprovalWorkInfo{
    requestId: string,
    status: string
  }
  export interface ACApprovalWorkflowData{
    approvalWorkflowList: ACApprovalWorkInfo []
  }
}